/* unplugin-vue-components disabled */import { render } from "./SelectionDialog.vue?vue&type=template&id=bd66111e"
import script from "./SelectionDialog.vue?vue&type=script&lang=js"
export * from "./SelectionDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__